
<template>
	<div class="qrcontainer">
		<div class="header">
			<div @click="back()">
				<img src="../../assets/images/whiteGo.png">
				<span>取消</span>
			</div>
			<div @click  ="setFlash">
				<!-- <img src="../../assets/images/flashlight.png">	 -->
			</div>
		</div>
		<div id= "bcid" :style="{width:width+'px',height:width*4/2.88+'px'}" >
		  <!-- <div class="open">轻点照亮</div> -->
		</div>
		<div class="footer" @touchend="scanPicture">相册</div>
	</div>
</template>
<style scoped>
/* .open{
	display: block;
 text-align: center;
 color: rgba(255, 255, 255, 255)
} */
.qrcontainer{
	/* 容器，沾满全屏 */
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index:100;
	font-size: .3rem;
	background:#000000;	
	}
	.header{
	/* 顶部开灯取消 */
		background:#000000;
		line-height: .9rem;
		height: 8%;
		position: absolute;
		width: 100%;
		z-index: 1000;
	}
	.header div img{
		display: inline-block;
		height: 0.3rem;
		vertical-align: middle;
	}
	.header div span{
		vertical-align: middle;
	}
	.footer{
		/* 底部相册选取 */
		position: absolute;
		left: 6.5rem;
		height: 8%;
		top: 0.05rem;
		line-height: .9rem;
		text-align: center;
		background:#000000;
        z-index: 1000;
		color: white;
		display: inline-block
    }
    .header div:nth-child(1){
			float: left;
            margin-left: .2rem;
            color: white
		}
    .header div:nth-child(2){
            margin-right: .2rem;
			/* color: white; */
			padding-top: 0.08rem;
		}
	 /* .header div:nth-child(2) img{
			   display: block;
				height: 1rem;
				width: auto;
			 margin-top: 9rem;
			 margin-left: 3.2rem
		   } */
	#bcid {	
		/* 扫描容器 */
	  width:100%;  
	  height:4rem;
	  /* background: red; */
	  position: absolute;  	
	  top:2%;
      background: #000000; 	
}
</style>
<script>
export default {
	data(){
		return{
			scan:null,
			light:"开灯",
			lightOpen:false,
			width: window.screen.width,
			height: window.screen.height,
		}
	},
	watch:{
		lightOpen(newVal,oldVal){
			if(newVal){
				this.light="关灯"
			}else{
				this.light="开灯"
			}
		}
	},
	methods:{
		onmarked( type, result ) {//扫描成功返回函数
					var text = '未知: ';
					switch(type){
						case plus.barcode.QR:
						text = 'QR: ';
						break;
						case plus.barcode.EAN13:
						text = 'EAN13: ';
						break;
						case plus.barcode.EAN8:
						text = 'EAN8: ';
						break;
					}
					alert( text+result );//处理生成二维码效果
					 let data={
									myphone:localStorage.myphone,
									mobilephone:result,
									userId:localStorage.userid,
								}
				   
					// this.$dialog.loading.open('请等待');
					// this.$router.back();//先返回
					this.$router.push({path:'/pay'});
					this.scan.cancel();
					this.scan.close();
				
			},
			back(){//顶部取消按钮
				history.go(-1);
				this.cancel()
			},
			cancel(){//关闭扫描控件方法
				this.scan.cancel();
				this.scan.close();	
			},
			startRecognize() {//创建扫描控件
				// var filter;//扫描控件样式
				var filter = [plus.barcode.QR];  
				var styles = {frameColor: "#29E52C",scanbarColor: "#29E52C",background: "transparent"}
						this.scan = new plus.barcode.Barcode('bcid',filter,styles);
						this.scan.onmarked =this.onmarked;
						this.startScan()
					},
			startScan() {//开始扫描
						this.scan.start();
					},
			 setFlash() {//开启闪光灯
				 
				 if(this.lightOpen){
					 this.scan.setFlash(false);
				 }else{
					this.scan.setFlash(true); 
				 }
				 this.lightOpen=!this.lightOpen;
				
			},
			 scanPicture() {//从相册选择图片识别
			 var onmarked=this.onmarked;
				plus.gallery.pick(function(path){
					plus.barcode.scan(path,onmarked,function(error){//错误处理函数
						alert( "无法识别此图片" );
					});
				},function(err){
					alert("Failed: "+err.message);
				});
		}
	},
	created(){

	},
	mounted(){
		var start=this.startRecognize;
		var back=this.cancel;
		setTimeout(function() {//组件加载完，延时启动扫描
				start();
		});
		plus.key.addEventListener("backbutton", function() {//安卓返回按键处理
					back()
				});
	},
	 deactivated(){//扫描完将组件销毁 
		this.$destroy()
	 },
}
</script>



// WEBPACK FOOTER //
// src/components/scan/scan.vue